(
function (skyward, $)
{
    skyward = skyward || {};
	skyward.crystalReporting = skyward.crystalReporting || {};

	skyward.window.registerLoadDOMCallback(function (selector)
	{
		$(selector).find(".customValueEntry:not(.bound) input").each(function ()
		{
			const jqThis = $(this);
			jqThis.on("keydown", function (event)
			{
				const eventKeys = skyward.keys.getKeyNamesFromEvent(event);
				if (eventKeys.ENTER)
				{
					jqThis.next().click();
				}
			});
			jqThis.addClass("bound");
		});
	});

    //CRYSTAL REPORTS FILTER PROMPTS
    skyward.crystalReporting.validateFields = function (e)
	{
	    e.preventDefault();
	    var inputsValid = true;
	    var errorData = { errors: {} };

        $(".CrystalReportParameterInput").each(function ()
	    {
	        var input = $(this);
	        var promptInputData = input.data();
	        var fieldName = input.closest('fieldset').find(".title").text();

	        var val = skyward.controls.getValue(input);

	        if ((val.isValidDate && !val.isValidDate()) || val.toString().trim().length === 0)
	        {
	            // substring removes the * from the field name
	            errorData.errors[promptInputData.validateControlFor] = ["'" + fieldName.substring(1) + "' is a required field."];
	            inputsValid = false;
	        }
	    });

	    if (inputsValid === false)
	    {
            skyward.validation.displayValidationMessages(errorData, $('.workflowContent'), $('#baseWorkflowErrorContainer'));
            e.stopPropagation();
	    }
	    return inputsValid;
	};

}(window.skyward = window.skyward || {}, window.jQuery)
)